module.exports = __webpack_public_path__ + "img/shop-icon-02.c4b71ac9.png";